import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Mail, ScrollText } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-border/60 bg-secondary/30 sm:mt-24" data-testid="footer">
      <div className="mx-auto grid max-w-screen-2xl gap-8 px-4 py-10 sm:px-6 sm:py-14 md:grid-cols-4 md:gap-10 lg:px-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <div className="relative h-9 w-9 rounded-2xl bg-primary grid place-items-center rotate-[-4deg] shadow-md cartoon-border">
              <span className="font-[Outfit] text-lg font-bold text-primary-foreground">P</span>
              <span className="absolute -right-1 -bottom-1 h-3 w-3 rounded-full bg-accent ring-2 ring-secondary" />
            </div>
            <span className="font-[Outfit] text-xl tracking-tight font-semibold">Price</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-muted-foreground">
            Price — l&apos;app conviviale de covoiturage qui met en relation
            passagers et chauffeurs pour des trajets partagés, simples et abordables.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider text-muted-foreground">Plateforme</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li>Réservation rapide</li>
            <li>Suivi de course</li>
            <li>Paiement sécurisé</li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider text-muted-foreground">Légal &amp; contact</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <Link
                to="/privacy"
                className="inline-flex items-center gap-1.5 text-foreground/80 underline-offset-2 hover:text-primary hover:underline"
                data-testid="footer-privacy-link"
              >
                <ShieldCheck className="h-3.5 w-3.5" />
                Confidentialité &amp; données
              </Link>
            </li>
            <li>
              <Link
                to="/cgu"
                className="inline-flex items-center gap-1.5 text-foreground/80 underline-offset-2 hover:text-primary hover:underline"
                data-testid="footer-cgu-link"
              >
                <ScrollText className="h-3.5 w-3.5" />
                Conditions d'utilisation
              </Link>
            </li>
            <li>
              <a
                href="mailto:saor.pro@icloud.com"
                className="inline-flex items-center gap-1.5 text-foreground/80 underline-offset-2 hover:text-primary hover:underline"
              >
                <Mail className="h-3.5 w-3.5" />
                saor.pro@icloud.com
              </a>
            </li>
            <li className="text-muted-foreground">Situé à Nice</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border/60 bg-secondary/40">
        <div className="mx-auto max-w-screen-2xl px-4 py-4 text-xs text-muted-foreground sm:px-6 lg:px-10" data-testid="footer-account-deletion">
          <p>
            <strong className="text-foreground">Suppression de compte :</strong>{" "}
            Pour toute demande de suppression de votre compte, veuillez nous contacter à l'adresse suivante :{" "}
            <a
              href="mailto:saor.pro@icloud.com?subject=Demande%20de%20suppression%20de%20compte%20Saor"
              className="font-medium text-primary underline-offset-2 hover:underline"
            >
              saor.pro@icloud.com
            </a>
            .
          </p>
        </div>
      </div>

      <div className="border-t border-border/60">
        <div className="mx-auto flex max-w-screen-2xl flex-col gap-3 px-4 py-5 text-xs text-muted-foreground sm:px-6 sm:py-6 md:flex-row md:items-center md:justify-between lg:px-10">
          <span>© {new Date().getFullYear()} Price — Tous droits réservés.</span>
          <div className="flex items-center gap-3">
            <Link
              to="/privacy"
              className="text-[11px] underline-offset-2 hover:text-primary hover:underline"
              data-testid="footer-privacy-bottom-link"
            >
              Politique de confidentialité
            </Link>
            <Link
              to="/cgu"
              className="text-[11px] underline-offset-2 hover:text-primary hover:underline"
              data-testid="footer-cgu-bottom-link"
            >
              CGU
            </Link>
            <Link
              to="/login?admin=1"
              className="inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-3 py-1.5 text-[11px] font-medium text-muted-foreground transition-colors hover:border-primary/60 hover:text-primary"
              data-testid="footer-admin-login"
            >
              <ShieldCheck className="h-3 w-3" />
              Espace administration
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
